<template>
  <a :href="href"></a>
</template>

<script>
export default {
  props: {
    href: {
      type: String
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// components/_UI/BaseExternalLink.vue